import { render, staticRenderFns } from "./PlatonFilterElement.vue?vue&type=template&id=1b5e75ec"
import script from "./PlatonFilterElement.vue?vue&type=script&lang=js"
export * from "./PlatonFilterElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports